<template>
<svg viewBox="0 0 14 14" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-ZhuoMianHua`]" width="1em" height="1em" v-bind="$attrs"><path d="M10.0049 8.50447L10.5012 8.00126L13.1238 10.6899L12.3874 11.3664L10.0049 8.50447Z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M4.03284 1C3.55011 1 3.13629 1.34485 3.04924 1.81967L1.2159 11.8197C1.10329 12.4339 1.57501 13 2.19951 13H8.96618C9.44891 13 9.86273 12.6551 9.94978 12.1803L11.7831 2.18033C11.8957 1.56607 11.424 1 10.7995 1H4.03284ZM4.65227 2C4.16898 2 3.75485 2.34562 3.6684 2.82112L2.21385 10.8211C2.10225 11.435 2.57382 12 3.19772 12H8.43766C8.92095 12 9.33508 11.6544 9.42153 11.1789L10.8761 3.17889C10.9877 2.56504 10.5161 2 9.89221 2H4.65227Z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M5.01242 6.58386L4.21059 8.64992H8.10429L7.56482 7.67958L7.06173 7.92497C6.88369 8.01182 6.67115 7.98536 6.51983 7.85751L5.01242 6.58386ZM4.46125 6.06928C4.58546 5.74924 4.98785 5.6467 5.25008 5.86826L6.87203 7.23867L7.42831 6.96733C7.66715 6.85083 7.95539 6.94151 8.08452 7.17376L8.88132 8.60697C9.0666 8.94024 8.82562 9.34992 8.44431 9.34992H3.91844C3.56691 9.34992 3.32513 8.99674 3.45231 8.66902L4.46125 6.06928Z"/><circle cx="8.5" cy="5.5" r=".5"/></svg>
</template>
<script>

export default {
  name: 'IconZhuoMianHua',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
